<script setup lang="ts">
import { featureFlags } from '@/featureFlags';

interface Props {
  title: string;
  message: string;
}
defineProps<Props>();

const emit = defineEmits<{
  retry: [];
}>();

const titleClass = featureFlags.ANDEV_10719_INSIGHT_TOPIC_HINT_PAIR
  ? 'c-title-medium--m'
  : 'c-title-bold--m';
</script>

<template>
  <div class="error-container">
    <div>
      <div :class="titleClass">{{ title }}</div>
      <div class="c-text-regular--m">{{ message }}</div>
    </div>
    <button
      class="c-btn c-btn--small c-btn--auto c-btn--AnewsPrimary"
      @click="emit('retry')"
    >
      再度試す
    </button>
  </div>
</template>

<style lang="scss" scoped>
.error-container {
  display: flex;
  justify-content: space-between;
  padding: 16px;
  border: 1px solid $color-gray400;
  border-radius: 4px;
}
</style>
